module.exports = __webpack_public_path__ + "media/ambient.4d41383b.mp3";